import { useCallback } from "react";
import { type Schema } from "@pdfme/common";
import { PdfMeTemplateDialog } from "../../misc/PdfMeTemplateDialog";
import { DialogProps } from "../../misc/DialogProps";
import { type DrivingSchoolAutoForm } from "../../providers/autoFormsProvider";

export function AutoFormTemplateDialog(props: { autoForm: DrivingSchoolAutoForm } & DialogProps) {
  const { autoForm, ...dialogProps } = props;

  const onSubmit = useCallback(
    async (pdfTemplate: Schema[][]) => {
      await dataProvider.update("autoForms", {
        id: autoForm.id,
        data: { pdfTemplate },
        previousData: autoForm,
      });
    },
    [autoForm],
  );

  return <PdfMeTemplateDialog {...dialogProps} record={autoForm} onSubmit={onSubmit} />;
}
